"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4216],{

/***/ 54216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CurrentUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69661);
/* harmony import */ var _mui_material_Badge__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49425);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11057);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10224);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71496);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_UserNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27218);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59484);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96479);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15695);
/* harmony import */ var _Menu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76698);



















var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            zIndex: theme.zIndex.appBar
        },
        smallButton: {
            padding: 3,
            paddingRight: 8,
            border: "1px solid #dedede"
        },
        currentUser: {
            width: "100%"
        },
        label: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, theme.typography.body2), {
            display: "flex",
            flexDirection: "column",
            fontWeight: theme.typography.fontWeightMedium,
            alignItems: "flex-start",
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        }),
        username: {
            color: theme.palette.common.white,
            whiteSpace: "nowrap",
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        },
        avatar: {
            height: 24,
            width: 24,
            "&$largeAvatar": {
                height: 32,
                width: 32
            }
        },
        smallUserName: {
            fontSize: 14
        },
        smallAvatar: {
            height: 24,
            width: 24
        },
        largeAvatar: {},
        downChevron: {
            marginLeft: -4,
            "&.light": {
                color: theme.palette.common.white
            },
            "&.dark": {
                color: theme.palette.text.primary
            }
        },
        menu: {
            margin: theme.spacing(5, 0, 1, 0)
        },
        menuPaper: {
            minWidth: "13em",
            color: theme.palette.getContrastText("#363740"),
            backgroundColor: "#363740",
            borderRadius: theme.shape.borderRadius * 1.5
        }
    };
}, {
    classNamePrefix: "CurrentUser"
});
var CurrentUser = function(param) {
    var className = param.className, _color = param.color, color = _color === void 0 ? "light" : _color, _isOnboarding = param.isOnboarding, isOnboarding = _isOnboarding === void 0 ? false : _isOnboarding, _variant = param.variant, variant = _variant === void 0 ? "account" : _variant, size = param.size;
    var classes = useStyles();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_3__/* .useUserContext */ .SE)(), 1), ref1 = ref[0], user = ref1.user, isAuthenticated = ref1.isAuthenticated;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), open = ref2[0], setOpen = ref2[1];
    var anchorRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    // return focus to the button when we transitioned from !open -> open
    var prevOpen = react__WEBPACK_IMPORTED_MODULE_1__.useRef(open);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [
        open
    ]);
    var monogram = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_users__WEBPACK_IMPORTED_MODULE_10__/* .getUserMonogram */ .Sk)(user);
    }, [
        user
    ]);
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var handleClose = function(event) {
        var ref;
        if ((ref = anchorRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.root, className),
        children: !!user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            className: classes.currentUser,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u, {
                    title: user.email || "",
                    placement: "bottom",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        ref: anchorRef,
                        variant: "text",
                        size: "large",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, classes.smallButton, size === "small")),
                        "aria-controls": open ? "menu-list-grow" : undefined,
                        "aria-haspopup": "true",
                        onClick: handleToggle,
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Badge__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            badgeContent: 0,
                            color: "secondary",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.avatar, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, classes.largeAvatar, size === "large"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, classes.smallAvatar, size === "small"), _obj)),
                                src: user.avatarUrl,
                                alt: user.email,
                                title: user.email,
                                children: monogram
                            })
                        }),
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.downChevron, color)
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: classes.label,
                            children: function() {
                                switch(variant){
                                    case "account":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.label, color),
                                            children: "Account"
                                        });
                                    case "name":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            variant: "body1",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.username, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, classes.smallUserName, size === "small"), color),
                                            children: user.name
                                        });
                                }
                            }()
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu */ .v, {
                    className: classes.menu,
                    open: open,
                    classes: {
                        paper: classes.menuPaper
                    },
                    anchorEl: anchorRef.current,
                    role: undefined,
                    onClose: handleClose,
                    children: isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserNav__WEBPACK_IMPORTED_MODULE_2__/* .UserNav */ .T, {
                        isCollapsible: false,
                        showAvatar: false,
                        isOnboarding: isOnboarding,
                        onMenuClose: handleClose
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrentUser);


/***/ }),

/***/ 27218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ UserNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(77214);
/* harmony import */ var _mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(40876);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78462);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9875);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48885);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(49425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69661);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(59334);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(93395);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(57922);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41796);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10224);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_AppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64574);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59484);
/* harmony import */ var _hooks_useIntercom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10428);
/* harmony import */ var _hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52581);
/* harmony import */ var _hooks_useUsageData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38539);
/* harmony import */ var _utils_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63429);
/* harmony import */ var _utils_users__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96479);
/* harmony import */ var _billing_EditionBadge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64462);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34557);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15695);




















var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(theme) {
    return {
        listItem: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
            padding: theme.spacing(0.5, "22px", 1.5, 2),
            color: theme.palette.common.white,
            cursor: "pointer",
            whiteSpace: "nowrap",
            "&:hover": {
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_13__/* .alpha */ .Fq)(theme.palette.common.white, 0.075)
            }
        }, theme.breakpoints.up("sm"), {
            paddingBottom: theme.spacing(1)
        }),
        nestedListItem: {
            padding: theme.spacing(1, 2)
        },
        avatarListItem: {
            paddingLeft: theme.spacing(8)
        },
        label: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            margin: 0,
            whiteSpace: "nowrap"
        },
        navToggle: {
            opacity: 1,
            right: 8,
            transition: theme.transitions.create([
                "opacity"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
                delay: 25
            })
        },
        navToggleClosed: {
            opacity: 0,
            transition: theme.transitions.create([
                "opacity"
            ], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.shortest,
                delay: 0
            })
        },
        avatar: {
            height: 32,
            marginRight: theme.spacing(2),
            width: 32
        },
        navIcon: {
            minWidth: 0,
            justifyContent: "center",
            color: theme.palette.common.white,
            opacity: 0.8
        },
        userName: {
            lineHeight: 1,
            marginTop: theme.spacing(0.25),
            maxWidth: 160
        },
        listItemText: {
            fontWeight: theme.typography.fontWeightMedium,
            margin: 0
        },
        divider: {
            backgroundColor: "rgba(255,255,255,.1)"
        }
    };
}, {
    classNamePrefix: "UserNav"
});
var UserNav = function(param) {
    var _isCollapsible = param.isCollapsible, isCollapsible = _isCollapsible === void 0 ? true : _isCollapsible, _showAvatar = param.showAvatar, showAvatar = _showAvatar === void 0 ? true : _showAvatar, _isOnboarding = param.isOnboarding, isOnboarding = _isOnboarding === void 0 ? false : _isOnboarding, onMenuClose = param.onMenuClose;
    var classes = useStyles();
    var ref = (0,_context_AppContext__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)(), nav = ref.state.nav;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_3__/* .useUserContext */ .SE)(), 2), user = ref1[0].user, actions = ref1[1];
    var usageData = (0,_hooks_useUsageData__WEBPACK_IMPORTED_MODULE_6__/* .useUsageData */ .L)().usageData;
    var router = (0,_hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_5__/* .useOurRouter */ .ED)();
    var monogram = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_users__WEBPACK_IMPORTED_MODULE_15__/* .getUserMonogram */ .Sk)(user);
    }, [
        user
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var ref;
        return router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.startsWith((0,_utils_router__WEBPACK_IMPORTED_MODULE_7__/* .getBillingUrl */ .uN)());
    }), open = ref2[0], setOpen = ref2[1];
    var showIntercom = (0,_hooks_useIntercom__WEBPACK_IMPORTED_MODULE_4__/* .useIntercom */ .o)().showIntercom;
    var handleHelpClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose(event);
        showIntercom();
    }, [
        showIntercom,
        onMenuClose
    ]);
    var handleLogout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return actions === null || actions === void 0 ? void 0 : actions.logout();
    }, [
        actions
    ]);
    var handleMenuExpand = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        component: "nav",
        disablePadding: true,
        children: !!user && (!isOnboarding ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                    className: classes.listItem,
                    component: _Link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r,
                    href: "/users/self",
                    underline: "none",
                    children: [
                        showAvatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            className: classes.navIcon,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                badgeContent: 0,
                                color: "secondary",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.avatar, showAvatar),
                                    src: user.avatarUrl,
                                    alt: user.email,
                                    title: user.email,
                                    children: monogram
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_10__/* .Tooltip */ .u, {
                            title: user.email || "",
                            placement: "right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                primary: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        (usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_billing_EditionBadge__WEBPACK_IMPORTED_MODULE_8__/* .EditionBadge */ .M, {
                                            edition: usageData.currentEdition,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            className: classes.userName,
                                            noWrap: true,
                                            children: user.name
                                        })
                                    ]
                                }),
                                className: classes.label
                            })
                        }),
                        isCollapsible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.navToggle, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, classes.navToggleClosed, !nav.open)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                className: classes.navIcon,
                                onClick: handleMenuExpand,
                                size: "large",
                                children: !open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                    fontSize: "small",
                                    color: "inherit"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    fontSize: "small",
                                    color: "inherit"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                    in: open && nav.open || !isCollapsible,
                    timeout: "auto",
                    unmountOnExit: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            href: (0,_utils_router__WEBPACK_IMPORTED_MODULE_7__/* .getBillingUrl */ .uN)(),
                            underline: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Billing & Team",
                                    disableTypography: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            href: "/settings/accounts",
                            underline: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Calendars",
                                    disableTypography: true
                                })
                            })
                        }),
                        !isCollapsible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            className: classes.divider
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            href: "https://reclaim.ai/webinars-demos",
                            underline: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Webinars & Demos",
                                    disableTypography: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            href: "https://updates.reclaim.ai",
                            underline: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.listItemText,
                                    primary: "Product Updates",
                                    disableTypography: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                            button: true,
                            "data-intercom-target": "nav-help",
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                            onClick: handleHelpClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                primary: "Help",
                                className: classes.listItemText,
                                disableTypography: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                            button: true,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
                            onClick: handleLogout,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                className: classes.listItemText,
                                primary: "Log Out",
                                disableTypography: true
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
            button: true,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(classes.listItem, classes.nestedListItem, showAvatar && classes.avatarListItem),
            onClick: handleLogout,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                className: classes.listItemText,
                primary: "Log Out",
                disableTypography: true
            })
        }))
    });
};


/***/ }),

/***/ 64462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EditionBadge; }
/* harmony export */ });
/* unused harmony export EditionBadgeContext */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10224);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AppTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73916);
/* harmony import */ var _hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55004);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50084);
/* harmony import */ var _EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);












var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.keyframes */ .zd.keyframes), {
        root: {},
        loading: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.elementStyles */ .zd.elementStyles), {
            width: 50
        })
    });
}, {
    classNamePrefix: "EditionBadge"
});
var EditionBadgeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    tooltipOpen: false,
    setTooltipOpen: function() {
        return void 0;
    }
});
var EditionBadge = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var edition = _param.edition, className = _param.className, EditionBadgeBaseClasses = _param.EditionBadgeBaseClasses, showIfTrial = _param.showIfTrial, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "edition",
        "className",
        "EditionBadgeBaseClasses",
        "showIfTrial"
    ]);
    var classes = useStyles();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(EditionBadgeContext), tooltipOpen = _$ref.tooltipOpen, setTooltipOpen = _$ref.setTooltipOpen;
    var userIsOnTrial = (0,_hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__/* .useSubscriptionLogic */ .Y)().userIsOnTrial;
    var handleTouchEndCapture = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!tooltipOpen) {
            // preventDefault on touchEnd blocks click event
            e.preventDefault();
            e.stopPropagation();
            setTooltipOpen(true);
        } else setTooltipOpen(false);
    }, [
        setTooltipOpen,
        tooltipOpen
    ]);
    var loading = !edition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__/* .EditionBadgeBase */ .i, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onTouchEndCapture: handleTouchEndCapture,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, classes.loading, loading)),
        paid: edition !== "LITE" && edition !== "ASSISTANT",
        classes: EditionBadgeBaseClasses,
        ref: ref
    }, rest), {
        children: edition ? function() {
            var _edition = _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__/* .EDITION_META */ .JZ[edition], label = _edition.label, isTrial = _edition.isTrial;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    label,
                    showIfTrial && (isTrial || userIsOnTrial) ? " trial" : ""
                ]
            });
        }() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "\xa0"
        })
    }));
});
EditionBadge.displayName = "EditionBadge";


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ EditionBadgeBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10224);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.caption), {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.colors.grey, 0.6),
            borderRadius: 4,
            color: theme.palette.text.primary,
            display: "inline-block",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: "16px",
            padding: theme.spacing(0, 0.5),
            textTransform: "uppercase",
            pointerEvents: "auto",
            cursor: "default"
        }),
        paid: {
            backgroundColor: theme.colors.logo.corn
        },
        medium: {},
        small: {},
        slim: {}
    };
}, {
    classNamePrefix: "EditionBadgeBase"
});
var EditionBadgeBase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, _size = _param.size, size = _size === void 0 ? "medium" : _size, paid = _param.paid, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "size",
        "paid",
        "children"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.paid, paid), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.medium, size === "medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.slim, size === "slim"), _obj)),
        ref: ref
    }, rest), {
        children: children
    }));
});
EditionBadgeBase.displayName = "EditionBadgeBase";


/***/ }),

/***/ 55004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useSubscriptionLogic; }
/* harmony export */ });
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72897);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
/* harmony import */ var _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13811);
/* harmony import */ var _atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10352);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38539);





var useSubscriptionLogic = function() {
    var usageData = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_4__/* .useUsageData */ .L)().usageData;
    var ref = (0,_atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__/* .useTeamState */ .Oo)(true), team = ref.team, userMembership = ref.userMembership;
    /**
   * Member subscription
   */ var userCurrentEdition = usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition;
    var userTerminalEdition = usageData === null || usageData === void 0 ? void 0 : usageData.terminalEdition;
    var userUsageEdition = usageData === null || usageData === void 0 ? void 0 : usageData.usageEdition;
    var userIsAdmin = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole) === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin;
    var userIsOnRewards = !!userCurrentEdition && !!_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isReward;
    var userIsOnTrial = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.trial) && !userIsOnRewards;
    var userDaysLeftInTrial = userMembership === null || userMembership === void 0 ? void 0 : userMembership.daysLeftInTrial;
    var userTrialEnd = userMembership === null || userMembership === void 0 ? void 0 : userMembership.trialEnd;
    var userIsOnPaidSeat = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.paidSeat);
    var userCanRedeemRewards = (team === null || team === void 0 ? void 0 : team.members.length) === 1;
    /**
   * Team subscription
   */ var seats = team ? {
        used: team.pricingSummary.homogeneous ? team.membershipSummary.activeCount : team.totalSeatsUsed,
        purchased: team === null || team === void 0 ? void 0 : team.membershipSummary.paidCount
    } : {
        used: 1,
        purchased: 1
    };
    var subscriptionFrequency = team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionFrequency;
    var hasActiveSubscription = !!(team === null || team === void 0 ? void 0 : team.hasSubId);
    var teamHasAutoRenew = !!(team === null || team === void 0 ? void 0 : team.pricingSummary.autoRenew);
    var planCancelStatus = !!userCurrentEdition && !teamHasAutoRenew && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isNonPaid && !!(team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionEnd) ? {
        isCancelled: true,
        terminalDate: new Date(team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionEnd)
    } : {
        isCancelled: false
    };
    /**
   * Legacy plan support
   */ var userCanInvite = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canInvite */ .AE)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole, team === null || team === void 0 ? void 0 : team.userInviteLevel);
    var userCanChangeSettings = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canChangeSettings */ .M9)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole);
    var userCanSetInviteLevels = !(team === null || team === void 0 ? void 0 : team.pricingSummary.homogeneous) && userIsAdmin && (team === null || team === void 0 ? void 0 : team.userInviteLevel) !== "NONE";
    var pendingClawback = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.edition) === "ASSISTANT" && (usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition) !== "ASSISTANT";
    // TODO (RAI-7793)
    if (!(team === null || team === void 0 ? void 0 : team.newPricing) && userIsOnTrial) {
        userIsOnTrial = userIsOnTrial && (userMembership === null || userMembership === void 0 ? void 0 : userMembership.editionAfterTrial) !== "TEAM";
    }
    return {
        userCurrentEdition: userCurrentEdition,
        userTerminalEdition: userTerminalEdition,
        userUsageEdition: userUsageEdition,
        userIsAdmin: userIsAdmin,
        userIsOnTrial: userIsOnTrial,
        userDaysLeftInTrial: userDaysLeftInTrial,
        userTrialEnd: userTrialEnd,
        userIsOnPaidSeat: userIsOnPaidSeat,
        userIsOnRewards: userIsOnRewards,
        userCanRedeemRewards: userCanRedeemRewards,
        subscriptionFrequency: subscriptionFrequency,
        hasActiveSubscription: hasActiveSubscription,
        seats: seats,
        userCanInvite: userCanInvite,
        userCanChangeSettings: userCanChangeSettings,
        userCanSetInviteLevels: userCanSetInviteLevels,
        pendingClawback: pendingClawback,
        teamHasAutoRenew: teamHasAutoRenew,
        planCancelStatus: planCancelStatus
    };
};


/***/ }),

/***/ 96479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ schedulingLinkOrganizerViewToThinPerson; },
/* harmony export */   "Ri": function() { return /* binding */ userSyncsMaxedOut; },
/* harmony export */   "Sk": function() { return /* binding */ getUserMonogram; },
/* harmony export */   "nE": function() { return /* binding */ getNameAndEmailString; },
/* harmony export */   "sq": function() { return /* binding */ teamMemberToThinPerson; },
/* harmony export */   "wY": function() { return /* binding */ getMonogram; }
/* harmony export */ });
function getNameAndEmailString(param) {
    var email = param.email, firstName = param.firstName, lastName = param.lastName, name = param.name, compMaker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(name, email) {
        return "".concat(name, ", ").concat(email);
    };
    if (!name && (firstName || lastName)) name = [
        firstName,
        lastName
    ].join(" ");
    if (name) return compMaker(name, email);
    else return email || "";
}
var getMonogram = function(name, email) {
    if (!name && !email) return null;
    var chunks = !!name ? name.replace(/[^\w^\s]/gi, "").trim().split(/\s+/) : (email === null || email === void 0 ? void 0 : email.replace(/[^\w^\-^\.]/gi, "").replace(/^[\-\.]/gi, "").split(/[-.]/)) || [];
    return chunks.map(function(chunk) {
        return (chunk[0] || "").toUpperCase();
    }).join("");
};
var getUserMonogram = function(user) {
    if (!user || !!user.avatarUrl) return null;
    return getMonogram(user.name, user.email);
};
var userSyncsMaxedOut = function(user, policies) {
    var unlimitedSync = user === null || user === void 0 ? void 0 : user.entitlements.unlimitedSyncEnabled;
    var enabledPolicies = policies === null || policies === void 0 ? void 0 : policies.filter(function(i) {
        return !!i.enabled;
    }).length;
    return !unlimitedSync && !!enabledPolicies;
};
var teamMemberToThinPerson = function(teamMember) {
    return {
        userId: teamMember.teamMemberId.userId,
        email: teamMember.email,
        avatarUrl: teamMember.avatarUrl,
        firstName: teamMember.firstName,
        lastName: teamMember.lastName,
        name: teamMember.name
    };
};
var schedulingLinkOrganizerViewToThinPerson = function(org) {
    return {
        userId: org.organizer.userId,
        email: org.organizer.email,
        avatarUrl: org.organizer.avatarUrl,
        firstName: org.organizer.firstName,
        lastName: org.organizer.lastName,
        name: org.organizer.name
    };
};


/***/ })

}]);